import { render } from "./LGVideosPage.vue?vue&type=template&id=db20734e"
import script from "./LGVideosPage.vue?vue&type=script&lang=js"
export * from "./LGVideosPage.vue?vue&type=script&lang=js"

import "./LGVideosPage.vue?vue&type=style&index=0&id=db20734e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__